<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
	dark: {
		type: Boolean,
		default: false
	},
	absolute: {
		type: Boolean,
		default: false
	},
	inline: {
		type: Boolean,
		default: false
	},
	fillable: {
		type: Boolean,
		default: false
	},
	title: {
		type: String,
		default: ''
	},
	titleFont: {
		type: String,
		default: "font-regular"
	}
});
const modes = computed(() => {
	return {
		'core-loader_dark': props.dark,
		'core-loader_absolute': props.absolute,
		'core-loader_inline': props.inline,
		'core-loader_fillable': props.fillable
	};
});
</script>

<template>
	<div :class="['core-loader', modes]">
		<div class="core-loader__inner">
			<div class="core-loader__spinner"></div>
			<div v-if="title" :class="['core-loader__title', titleFont]">
				{{ title }}
			</div>
		</div>
	</div>
</template>

<style lang="scss">
.core-loader {
	margin-bottom: 2rem;
	color: var(--loader-color, var(--color-text));

	&:not(.core-loader_inline) {
		text-align: center;
		.core-loader {
			&__spinner {
				margin: auto;
			}
		}
	}

	&_fillable {
		display: flex;
		justify-content: center;
		align-items: center;
		flex: 1 1 auto;
	}

	&_inline {
		.core-loader {
			&__spinner {
				width: var(--loader-size, 2rem);
			}
			&__inner {
				flex-direction: row;
				align-items: center;
			}
		}
	}

	&_absolute {
		position: absolute;
		inset: 0px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	&_dark {
		--loader-color: #3B343B;
	}

	&__inner {
		display: flex;
		flex-direction: column;
		gap: 2rem;
	}

	&__title {
		flex: 1 1 auto;
	}

	&__spinner {
		width: var(--loader-size, 4rem);
		aspect-ratio: 1;
		border-radius: 50%;
		flex: 0 0 auto;
		border: var(--loader-width, 3px) solid var(--loader-color, currentColor);
		animation:
			l20-1 0.8s infinite linear alternate,
			l20-2 1.6s infinite linear;
	}
}

@keyframes l20-1{
	0%    {clip-path: polygon(50% 50%,0       0,  50%   0%,  50%    0%, 50%    0%, 50%    0%, 50%    0% )}
	12.5% {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100%   0%, 100%   0%, 100%   0% )}
	25%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 100% 100%, 100% 100% )}
	50%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
	62.5% {clip-path: polygon(50% 50%,100%    0, 100%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
	75%   {clip-path: polygon(50% 50%,100% 100%, 100% 100%,  100% 100%, 100% 100%, 50%  100%, 0%   100% )}
	100%  {clip-path: polygon(50% 50%,50%  100%,  50% 100%,   50% 100%,  50% 100%, 50%  100%, 0%   100% )}
}
@keyframes l20-2{
	0%    {transform:scaleY(1)  rotate(0deg)}
	49.99%{transform:scaleY(1)  rotate(135deg)}
	50%   {transform:scaleY(-1) rotate(0deg)}
	100%  {transform:scaleY(-1) rotate(-135deg)}
}
</style>
